import { Link } from 'react-router-dom';

const pills = [
  'AI Ad Copy',
  'AI Creative Images',
  'AI Creative Videos',
  'Visual Editor',
  'A/B Variations',
  'Multi-Platform',
  'One-Click Export',
];

export default function FeaturesHero() {
  return (
    <header className="relative min-h-[72vh] flex items-center justify-center overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=sleek%20modern%20software%20dashboard%20interface%20with%20glowing%20data%20panels%20and%20feature%20cards%20on%20a%20very%20dark%20charcoal%20background%2C%20cool%20amber%20and%20warm%20gold%20light%20accents%2C%20minimal%20tech%20aesthetic%2C%20cinematic%20wide%20shot%2C%20no%20text%2C%20ultra%20detailed%2C%20professional%20SaaS%20product%20feel&width=1920&height=900&seq=features-hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/75" />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 lg:px-8 text-center py-20">
        <span className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-400/30 text-orange-300 text-xs font-bold px-4 py-1.5 rounded-full mb-8 backdrop-blur-sm uppercase tracking-widest">
          Full Feature Breakdown
        </span>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-6">
          Every Feature You Need to Run{' '}
          <span className="text-orange-400">Better Ads with AI</span>
        </h1>

        <p className="text-lg text-stone-300 max-w-2xl mx-auto mb-8 leading-relaxed">
          AdForge is the most complete <strong className="text-white">AI ad generator</strong> for small businesses — combining AI copy, AI visuals, and a full creative editor in one place. No agency required.
        </p>

        {/* Feature pill tags */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {pills.map((p) => (
            <span
              key={p}
              className="text-xs font-semibold bg-white/10 border border-white/15 text-white/80 px-3 py-1.5 rounded-full backdrop-blur-sm"
            >
              {p}
            </span>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Try All Features Free
          </Link>
          <Link
            to="/how-it-works"
            className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            See How It Works
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent" />
    </header>
  );
}
